import { Carousel } from '../core'

$.fn.projectGallery = function() {
  let self = this
  self.carousel = undefined
  var spaceBetween = 0;
  if ($('body').hasClass('template-project-single-new')) {
    spaceBetween = 40;
  }

  return function() {
    self.carousel = new Carousel(self.find('.swiper-container').get(0), {
      slidesPerView: 1,
      autoHeight: true,
      loop: true,
      loopAdditionalSlides : 2,
      spaceBetween: spaceBetween,
      navigation: {
        prevEl: self.find('.swiper-button-prev').get(0),
        nextEl: self.find('.swiper-button-next').get(0),
      },
    })
    self.carousel.init()
    return self
  }()
}
